import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Package, ChevronDown, Tag, ArrowRight, Mail } from "lucide-react";
const heroImage =
  "/Images/services/oil-gas/chemical-products/chemical-products.webp";

const products = [
  {
    id: "g-surf-w-395",
    number: "01",
    name: "G-SURF W 395",
    category: "Surfactante",
    packaging: "55 Galones",
    image: "/Images/services/oil-gas/chemical-products/chemical-product-01.webp",
    description:
      "El G-SURF W 395 es un aditivo compuesto de diversos agentes surfactantes no iónicos, empleado en aplicaciones base agua para reducir la tensión interfacial de sistemas coloidales formados en fondo de pozo.",
    details:
      "Adicionalmente, mejora la compatibilidad de los sistemas por sus características de doble afinidad, contribuyendo al desempeño de las operaciones donde se requiere un control adecuado de las propiedades interfaciales.",
  },
  {
    id: "g-gel",
    number: "02",
    name: "G-GEL",
    category: "Arcilla Coloidal",
    packaging: "50 Libras",
    image: "/Images/services/oil-gas/chemical-products/chemical-product-01.webp",
    description:
      "G-GEL es una arcilla coloidal, definida químicamente como un silicato base alúmina. Es un material de origen volcánico, de color claro a crema y polvo impalpable.",
    details:
      "Por ser una roca arcillosa, para su uso es seleccionada, molida y clasificada por mallas, permitiendo obtener las características requeridas para sus diferentes aplicaciones.",
  },
  {
    id: "g-solv",
    number: "03",
    name: "G-SOLV",
    category: "Solvente mutual",
    packaging: "55 Galones",
    image: "/Images/services/oil-gas/chemical-products/chemical-product-01.webp",
    description:
      "G-SOLV es un producto especialmente diseñado para operaciones de limpieza del sistema de fondo de pozo y proximidad de la cara de la formación.",
    details:
      "También está orientado a aplicaciones de estimulación en pozos petroleros que han disminuido su tasa de producción, contribuyendo a las operaciones destinadas a recuperar su desempeño.",
  },
];

const ChemicalProducts = () => {
  const [openProduct, setOpenProduct] = useState(null);
  return (
    <>
      {/* HERO PRODUCTOS QUÍMICOS */}
      <section className="overflow-hidden">
        <div
          className="
      relative
      h-[520px]
      sm:h-[500px]
      md:h-[560px]
      lg:h-[580px]
      xl:h-[600px]
    "
        >
          <img
            src={heroImage}
            alt="Productos químicos especializados para la industria de petróleo y gas"
            className="
        absolute
        inset-0
        w-full
        h-full
        object-cover
        object-[center_40%]
        sm:object-[center_40%]
        md:object-[center_35%]
        lg:object-[center_35%]
      "
          />

          <div className="absolute inset-0 bg-black/20" />

          <div
            className="
        absolute
        inset-0
        bg-gradient-to-r
        from-black/75
        via-black/45
        to-transparent
      "
          />

          <div className="absolute inset-0 flex items-center">
            <div
              className="
          w-full
          max-w-7xl
          mx-auto
          px-4
          sm:px-6
          lg:px-8
        "
            >
              <div
                className="
            max-w-3xl
            pt-10
            sm:pt-12
            md:pt-14
          "
              >
                <span
                  className="
              inline-flex
              items-center
              px-3
              py-1.5
              sm:px-4
              sm:py-2
              rounded-full
              bg-[#ee7d32]/20
              border
              border-[#ee7d32]/30
              text-[#ee7d32]
              text-xs
              sm:text-sm
              font-semibold
              uppercase
              tracking-wider
            "
                >
                  Servicios
                </span>

                <h1
                  className="
              mt-4
              sm:mt-5
              md:mt-6
              text-4xl
              sm:text-5xl
              md:text-6xl
              lg:text-7xl
              font-bold
              text-white
              leading-[0.95]
              tracking-tight
            "
                >
                  Productos químicos
                  <br />
                  <span className="text-[#ee7d32]">especializados</span>
                </h1>
                <p
                  className="
              mt-4
              sm:mt-5
              md:mt-6
              text-base
              sm:text-lg
              md:text-xl
              text-white/90
              leading-7
              md:leading-8
              max-w-2xl
            "
                >
                  Soluciones químicas diseñadas para responder a las necesidades
                  específicas de las operaciones de petróleo y gas.
                </p>

                <p
                  className="
              mt-3
              sm:mt-4
              md:mt-5
              text-sm
              sm:text-base
              text-white/80
              leading-6
              sm:leading-7
              max-w-2xl
            "
                >
                  Contamos con productos especializados para aplicaciones de
                  perforación, completamiento, producción y mantenimiento,
                  orientados a mejorar el desempeño y la eficiencia de cada
                  operación.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PORTAFOLIO DE PRODUCTOS */}
      <section className="relative py-20 md:py-28 bg-[#f3f3f3] overflow-hidden">
        <div
          className="
      absolute
      top-0
      right-0
      w-[420px]
      h-[420px]
      rounded-full
      bg-[#ee7d32]/[0.035]
      blur-3xl
      pointer-events-none
    "
        />

        <div
          className="
      absolute
      bottom-0
      left-0
      w-[350px]
      h-[350px]
      rounded-full
      bg-[#ee7d32]/[0.025]
      blur-3xl
      pointer-events-none
    "
        />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mb-14 md:mb-18">
            <div className="w-14 h-1 bg-[#ee7d32] rounded-full mb-5" />

            <span
              className="
          inline-flex
          items-center
          gap-2
          text-xs
          sm:text-sm
          font-bold
          uppercase
          tracking-[0.16em]
          text-[#ee7d32]
        "
            >
              Portafolio de productos
            </span>

            <h2
              className="
          mt-5
          text-3xl
          sm:text-4xl
          md:text-5xl
          font-bold
          text-[#111]
          leading-[1.08]
          tracking-tight
        "
            >
              Soluciones químicas para{" "}
              <span className="text-[#ee7d32]">operaciones exigentes</span>
            </h2>

            <p
              className="
          mt-6
          max-w-2xl
          text-sm
          sm:text-base
          md:text-lg
          leading-7
          md:leading-8
          text-[#666]
        "
            >
              Nuestro portafolio incluye productos especializados para
              diferentes aplicaciones dentro de la industria de petróleo y gas,
              desarrollados para responder a los desafíos específicos de cada
              operación.
            </p>
          </div>

          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-7">
            {products.map((product) => {
              const isOpen = openProduct === product.id;

              return (
                <article
                  key={product.id}
                  className="
              group
              relative
              flex
              flex-col
              bg-white
              border
              border-[#e7e7e7]
              rounded-2xl
              overflow-hidden
              transition-all
              duration-500
              hover:border-[#ee7d32]/30
              hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)]
            "
                >
                  <div
                    className="
                relative
                h-[290px]
                sm:h-[320px]
                bg-[#fafafa]
                overflow-hidden
              "
                  >
                    <div
                      className="
                  absolute
                  top-5
                  left-6
                  z-20
                  flex
                  items-center
                  gap-2
                "
                    >
                      <span
                        className="
                    text-xs
                    font-bold
                    tracking-[0.2em]
                    text-[#aaa]
                  "
                      >
                        {product.number}
                      </span>

                      <span className="w-8 h-px bg-[#ddd]" />
                    </div>

                    <div
                      className="
                  absolute
                  inset-0
                  flex
                  items-center
                  justify-center
                  p-8
                  sm:p-10
                "
                    >
                      <img
                        src={product.image}
                        alt={product.name}
                        className="
                    w-full
                    h-full
                    object-contain
                    transition-transform
                    duration-700
                    ease-out
                    group-hover:scale-105
                  "
                      />
                    </div>

                    <div
                      className="
                  absolute
                  bottom-5
                  left-6
                  z-20
                "
                    >
                      <span
                        className="
                    inline-flex
                    items-center
                    gap-2
                    bg-white
                    border
                    border-[#e8e8e8]
                    rounded-md
                    px-3
                    py-2
                    text-[11px]
                    font-bold
                    uppercase
                    tracking-wider
                    text-[#555]
                    shadow-sm
                  "
                      >
                        <Tag size={14} strokeWidth={1.8} stroke="#ee7d32" />

                        {product.category}
                      </span>
                    </div>
                  </div>

                  <div
                    className="
                flex
                flex-col
                flex-1
                p-6
                sm:p-7
              "
                  >
                    <h3
                      className="
                  text-2xl
                  font-bold
                  text-[#111]
                  leading-tight
                "
                    >
                      {product.name}
                    </h3>

                    <p
                      className="
                  mt-4
                  text-sm
                  sm:text-[15px]
                  text-[#666]
                  leading-7
                "
                    >
                      {product.description}
                    </p>

                    <div
                      className={`
                  grid
                  transition-all
                  duration-500
                  ease-in-out
                  ${
                    isOpen
                      ? "grid-rows-[1fr] opacity-100 mt-5"
                      : "grid-rows-[0fr] opacity-0"
                  }
                `}
                    >
                      <div className="overflow-hidden">
                        <div
                          className="
                      border-l-2
                      border-[#ee7d32]
                      pl-4
                      py-1
                    "
                        >
                          <span
                            className="
                        text-[11px]
                        font-bold
                        uppercase
                        tracking-[0.14em]
                        text-[#ee7d32]
                      "
                          >
                            Información adicional
                          </span>

                          <p
                            className="
                        mt-2
                        text-sm
                        text-[#666]
                        leading-6
                      "
                          >
                            {product.details}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      className="
                  mt-auto
                  pt-6
                  mt-7
                  border-t
                  border-[#eeeeee]
                "
                    >
                      <div
                        className="
                    flex
                    items-end
                    justify-between
                    gap-4
                  "
                      >
                        <div className="flex items-center gap-3">
                          <div
                            className="
    flex
    items-center
    justify-center
    w-10
    h-10
    rounded-lg
    bg-[#fff3eb]
  "
                          >
                            <Package
                              size={20}
                              strokeWidth={1.8}
                              stroke="#ee7d32"
                            />
                          </div>

                          <div>
                            <span
                              className="
                          block
                          text-[10px]
                          font-bold
                          uppercase
                          tracking-wider
                          text-[#999]
                        "
                            >
                              Empaque
                            </span>

                            <span
                              className="
                          block
                          mt-0.5
                          text-sm
                          font-bold
                          text-[#222]
                        "
                            >
                              {product.packaging}
                            </span>
                          </div>
                        </div>

                        <button
                          type="button"
                          onClick={() =>
                            setOpenProduct(isOpen ? null : product.id)
                          }
                          aria-expanded={isOpen}
                          className="
    group/details
    inline-flex
    items-center
    gap-2
    text-sm
    font-bold
  "
                        >
                          <span
                            className="
      text-[#222]
      transition-colors
      duration-300
      group-hover/details:text-[#ee7d32]
    "
                          >
                            {isOpen ? "Ver menos" : "Ver detalles"}
                          </span>

                          <span
                            className="
      flex
      items-center
      justify-center
      w-8
      h-8
      border
      border-[#222]
      transition-colors
      duration-300
      group-hover/details:border-[#ee7d32]
    "
                          >
                            <ChevronDown
                              size={16}
                              strokeWidth={2}
                              className={`
        stroke-[#222]
        transition-colors
        duration-300
        group-hover/details:stroke-[#ee7d32]
        ${isOpen ? "rotate-180" : ""}
      `}
                            />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA PRODUCTOS QUÍMICOS */}
      <section className="relative py-10 md:py-12 bg-white overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className="
        group
        relative
        overflow-hidden
        rounded-[30px]
        border
        border-[#ececec]
        bg-white
        shadow-[0_12px_40px_rgba(0,0,0,0.05)]
        transition-all
        duration-300
        hover:shadow-[0_20px_60px_rgba(0,0,0,0.10)]
      "
          >
            <div
              className="
          absolute
          top-0
          left-0
          h-full
          w-1.5
          bg-gradient-to-b
          from-[#ee7d32]
          via-[#ee7d32]/50
          to-transparent
        "
            />

            <div
              className="
          flex
          flex-col
          lg:flex-row
          lg:items-center
          lg:justify-between
          gap-8
          px-6
          py-8
          md:px-10
          md:py-9
        "
            >
              <div className="flex flex-col sm:flex-row items-start gap-5 max-w-3xl">
                <div className="relative flex-shrink-0">
                  <div
                    className="
                absolute
                inset-0
                bg-[#ee7d32]/20
                blur-xl
                rounded-2xl
              "
                  />

                  <div
                    className="
                relative
                w-14
                h-14
                md:w-16
                md:h-16
                rounded-2xl
                flex
                items-center
                justify-center
              "
                  >
                    <Mail size={40} stroke="#ee7d32" strokeWidth={1.8} />
                  </div>
                </div>

                <div>
                  <span
                    className="
                inline-flex
                items-center
                rounded-full
                bg-[#ee7d32]/10
                border
                border-[#ee7d32]/20
                px-3
                py-1
                text-[11px]
                md:text-[12px]
                font-semibold
                uppercase
                tracking-widest
                text-[#ee7d32]
              "
                  >
                    Productos Químicos
                  </span>

                  <h3
                    className="
                mt-3
                text-2xl
                sm:text-3xl
                font-bold
                text-[#111]
                leading-tight
              "
                  >
                    ¿Necesitas más información sobre nuestros Productos
                    Químicos?
                  </h3>

                  <p
                    className="
                mt-3
                text-sm
                md:text-base
                leading-7
                text-[#6b7280]
                max-w-2xl
              "
                  >
                    Conoce nuestro portafolio de productos químicos y encuentra
                    soluciones adaptadas a las necesidades de tus operaciones.
                  </p>
                </div>
              </div>

              <div className="flex w-full lg:w-auto">
                <Link
                  to="/contact-us?division=oilgas&service=Productos químicos"
                  className="
              group/btn
              inline-flex
              w-full
              sm:w-auto
              items-center
              justify-center
              gap-3
              rounded-lg
              bg-[#ee7d32]
              px-6
              py-3.5
              md:px-7
              md:py-4
              text-sm
              font-semibold
              text-white
              transition-all
              duration-300
              hover:bg-[#e56f20]
              hover:shadow-lg
              hover:shadow-[#ee7d32]/20
            "
                >
                  Solicita información
                  <ArrowRight
                    size={18}
                    stroke="#ffffff"
                    strokeWidth={2}
                    className="
                transition-transform
                duration-300
                group-hover/btn:translate-x-1
              "
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default ChemicalProducts;
